// 币种
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("currency") || ""
}

const getters = {
  getCurrency:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("currency",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("currency")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
